import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import Dashboard from './Dashboard';
import ConceptsPipeline from './ConceptsPipeline';
import ContentLibrary from './ContentLibrary';
import ReviewsQueue from './ReviewsQueue';
import AdminPanel from './AdminPanel';
import ClientTraining from './client/ClientTraining';
import { getTrainingCapabilities } from './api';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'concepts', label: 'Concepts' },
  { id: 'library', label: 'Library' },
  { id: 'reviews', label: 'Reviews' },
  { id: 'admin', label: 'Admin' },
];

export default function TrainingIntelligence() {
  const [tab, setTab] = useState('overview');
  // The overview's counts are now links, so it needs to be able to open the tab (and
  // the Admin sub-section) that actually clears the work it is reporting.
  const [adminSection, setAdminSection] = useState(null);
  const navigate = (target, opts = {}) => {
    setAdminSection(target === 'admin' ? opts.section || null : null);
    setTab(target);
  };
  // The server decides the view: 'internal' (Training team + global admins) sees
  // the full workings; everyone else (external clients AND internal non-team
  // staff) gets the client view.
  const { data, isLoading } = useQuery({ queryKey: ['training-me'], queryFn: getTrainingCapabilities });

  if (isLoading) return <div className="p-6 text-sm text-gray-500">Loading...</div>;
  if (data?.view !== 'internal') return <ClientTraining />;
  const visibleTabs = TABS;
  return (
    <div className="p-4 md:p-6 max-w-[1280px] mx-auto">
      <div className="flex gap-1 border-b border-gray-200 dark:border-gray-700 mb-5">
        {visibleTabs.map((t) => (
          <button
            key={t.id}
            onClick={() => navigate(t.id)}
            className={`px-4 py-2 text-sm ${
              tab === t.id
                ? 'border-b-2 border-blue-500 font-semibold text-blue-600 dark:text-blue-400'
                : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'overview' && <Dashboard onNavigate={navigate} />}
      {tab === 'concepts' && <ConceptsPipeline />}
      {tab === 'library' && <ContentLibrary />}
      {tab === 'reviews' && <ReviewsQueue />}
      {tab === 'admin' && <AdminPanel isDirector={data?.is_director} initialSection={adminSection} />}
    </div>
  );
}
